export default "__VITE_ASSET__BofjNb57__"